import state from './roleState'
import mutations from './roleMutations'
import getters from './roleGetters'
import actions from './roleActions'

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
